import { z } from 'zod';

// Canonical envelope written to every `dlq:writes:*` Redis Stream by
// `createStreamConsumer` when an event fails handler processing or schema
// parsing. The DLQ replayer worker (Sprint 5) consumes this format to retry
// the original work, escalate to operators, or page on accumulating depth.
//
// `originalData` is the raw JSON string emitted by the original producer
// (preserved verbatim so replay reconstitutes byte-identical input). It is a
// string rather than a parsed object so a malformed-JSON event can still be
// captured for forensic analysis.
export const DlqPayloadSchema = z.object({
  // Source stream where the message originally lived (e.g. 'score.event').
  originalStream: z.string().min(1),
  // Original Redis Stream entry ID (e.g. '1736089123456-0').
  originalId: z.string().min(1),
  // Raw JSON payload. Null when the entry had no `data` field at all.
  originalData: z.string().nullable(),
  // First-line error message from the failing handler / parser.
  error: z.string().min(1),
  // UTC ISO8601 timestamp of when the DLQ entry was written.
  failedAt: z
    .string()
    .datetime({ offset: true })
    .refine((s) => s.endsWith('Z'), { message: 'failedAt must be UTC (Z suffix)' }),
});

export type DlqPayload = z.infer<typeof DlqPayloadSchema>;
